import { makeStyles } from '@material-ui/core';
import classnames from 'classnames';
import capitalize from 'lodash/capitalize';
import React from 'react';

import { Colors } from 'src/common/ui/base';
import { ScreeningStatusColorMap, ScreeningStatusLabelMap } from 'src/drugScreening/domain';

type DrugScreeningStatusProps = {
  screeningStatus: string | undefined;
  defaultLabel: string;
};

export const DrugScreeningStatus = ({
  screeningStatus,
  defaultLabel,
}: DrugScreeningStatusProps) => {
  const styles = useStyles();

  if (!screeningStatus) {
    return <span>{defaultLabel}</span>;
  }

  const shortText = capitalize(ScreeningStatusLabelMap[screeningStatus] ?? defaultLabel);
  const statusClass = ScreeningStatusColorMap[screeningStatus];

  if (statusClass !== 'warning' && statusClass !== 'error') {
    return <span>{shortText}</span>;
  }

  return (
    <span className={classnames(statusClass ? styles.chip : {}, styles[statusClass])}>
      {shortText}
    </span>
  );
};

const useStyles = makeStyles({
  chip: {
    alignItems: 'center',
    alignSelf: 'flex-start',
    borderRadius: 4,
    display: 'flex',
    fontSize: 14,
    fontWeight: 600,
    letterSpacing: 0.201,
    lineHeight: '100%',
    padding: '2px 4px',
  },
  warning: {
    backgroundColor: Colors.Yellow1,
    border: `1px solid ${Colors.Yellow2}`,
    color: Colors.Yellow2,
  },
  error: {
    backgroundColor: Colors.Red1,
    border: `1px solid ${Colors.Red4}`,
    color: Colors.Red4,
  },
});
